import React, { useState, useEffect } from 'react';
import logo from './logo.png';
import './App.css';
import { fetchData } from './service/avwapp.service';
import CanvasItem from './avwapp.chart';
import { host } from './env'

function App() {
  const [data, setData] = useState<any>([]);
  const [symbolsCsv, setSymbolsCsv] = useState<any>('');
  const [chartsData, setChartsData] = useState<[]>([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  var now = new Date();
  var month = now.getMonth() + 1;
  var monthStr = '';
  if (month < 10) {
    monthStr = '0' + month;
  } else {
    monthStr = month + '';
  }

  var dateStr = now.getDate() + '';
  if (now.getDate() < 10) {
    dateStr = '0' + now.getDate();
  }
  var defaultDateStr = now.getFullYear() + '-' + monthStr + '-' + dateStr;

  const [dateInputValue, setDateInputValue] = useState<string>(defaultDateStr);

  // Handle changes in the input
  const handleDateInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setDateInputValue(event.target.value);
  };
  const fetchDataFromApi = async () => {
    try {
      const result = await fetchData(
        `${host}/tickers-by-date?sqlDate=` + dateInputValue,
      );
      setData(result);
      var symbolsList = data as Array<String>;
      let symbolsCsvTmp = symbolsList.join(',');
      setSymbolsCsv(symbolsCsvTmp);
      fetchCharts();
      // chart.result[0].meta.symbol
    } catch (err) {
      setError('Failed to fetch data');
      console.log('err', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCharts = async () => {
    try {
      const result = await fetchData(`${host}/latest-hvc-charts`);
      setChartsData(result);
      console.log('Charts', chartsData);
    } catch (err) {
      setError('Failed to fetch data');
      console.log('err', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataFromApi();
  
  }, 
  []); // Empty dependency array ensures this runs once when the component mounts

  const handleFetchClick = async () => {
    fetchDataFromApi();
  };

  return (
    <div className="App">
      <header>
      <span className="avwapp-title">avwapp</span>
      <img src={logo} className="logo" alt="logo" />
      </header>

      <div>
 
      <h2>{dateInputValue}</h2>
        <h3>
          25% Higher volume than 3 month avg volume (eod), only stocks with an up day are shown. Biotechs and non US stocks are filtered out.
        </h3>

       

        {/*<input
          type="text"
          value={dateInputValue}
          onChange={handleDateInputChange}
        ></input>

         <button onClick={handleFetchClick}>Fetch for {dateInputValue}</button>
        <p> finviz link (usa filter) {data.length} total</p>
        <a
          href={`https://finviz.com/screener.ashx?v=111&f=geo_usa&t=/${symbolsCsv}&o=tickersfilter`}
        >
          {symbolsCsv}
        </a>*/}

        <div>
          {chartsData.map((chartObj, index) => (
            <CanvasItem
              width={500}
              height={500}
              index={index}
              chartData={chartObj}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
